import { render, staticRenderFns } from "./StateMedicalOfficer.vue?vue&type=template&id=5d924492&scoped=true"
import script from "./StateMedicalOfficer.vue?vue&type=script&lang=js"
export * from "./StateMedicalOfficer.vue?vue&type=script&lang=js"
import style0 from "./StateMedicalOfficer.vue?vue&type=style&index=0&id=5d924492&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d924492",
  null
  
)

export default component.exports